<section class="not-implemented">
  <h1>Coming Soon</h1>
  <p>This page is not ready yet. Please check back later.</p>

  <a class="not-implemented__link" routerLink="/home">
    Return to the dashboard
  </a>
</section>
